export default "__VITE_ASSET__C_INWvp___"